import palette from '@lib/core/src/theme/palette';
import { Button } from '@mui/material';
import { styled } from '@mui/material';

export const CalendarInviteButton = styled(Button)({
  height: '28px',
  fontSize: '12px',
  color: palette.purple[300],
  textTransform: 'none',
  borderRadius: '16px',
  marginBottom: '20px'
});
